import { NativeOutstreamBuilder } from './NativeOutstreamBuilder/NativeOutstreamBuilder';

const nativeOutstreamBuilder = (
  reactDirective,
  $modal,
  $rootScope,
  CreativeService,
  SaveCreativeService
) => {
  return reactDirective(
    NativeOutstreamBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      $modal,
      $rootScope,
      CreativeService,
      SaveCreativeService
    }
  );
};

nativeOutstreamBuilder.$inject = [
  'reactDirective',
  '$modal',
  '$rootScope',
  'CreativeService',
  'SaveCreativeService'
];

export default nativeOutstreamBuilder;
